import apiClient from '../lib/api-client';

export const pensionSchemeService = {
  // Select a specific pension scheme
  selectScheme: async (schemeData) => {
    try {
      // Normalize dateJoined to YYYY-MM-DD if possible
      const normalizeDate = (input) => {
        if (!input) return '';
        // If already YYYY-MM-DD, return as is
        const isoDateMatch = input.match(/^\d{4}-\d{2}-\d{2}/);
        if (isoDateMatch) return isoDateMatch[0];
        // If format contains space (e.g. 'YYYY-MM-DD HH:MM:SS'), take the date part
        if (input.includes(' ')) return input.split(' ')[0];
        // If other common separators, try to parse
        const parsed = new Date(input);
        if (!Number.isNaN(parsed.getTime())) {
          return parsed.toISOString().slice(0, 10);
        }
        return input;
      };
      const formData = new FormData();
      
      // Map the scheme data to form fields
      formData.append('member_name', schemeData.memberName || '');
      formData.append('employer_number', schemeData.employerNumber || '');
      formData.append('employer_name', schemeData.employerName || '');
      formData.append('ssnit_number', schemeData.ssnitNumber || '');
      formData.append('member_number', schemeData.memberNumber || '');
      formData.append('master_scheme', schemeData.masterScheme || '');
      formData.append('scheme_type', schemeData.schemeType || '');
      formData.append('email', schemeData.email || '');
      formData.append('dob', schemeData.dob || '');
  formData.append('date_joined', normalizeDate(schemeData.dateJoined) || '');
      formData.append('sex', schemeData.sex || '');
      formData.append('nationality', schemeData.nationality || '');

      // Let the HTTP client set the appropriate Content-Type and boundary for FormData
      const response = await apiClient.post('/member/select-scheme', formData);

      return response.data;
    } catch (error) {
      console.error('Error selecting pension scheme:', error);
      throw error;
    }
  },

  // Get beneficiaries for the currently selected scheme
  getBeneficiaries: async () => {
    try {
      const response = await apiClient.get('/beneficiaries');
      return response.data;
    } catch (error) {
      console.error('Error fetching beneficiaries:', error);
      throw error;
    }
  }
};
